import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-5",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "fw-bold me-2" }
const _hoisted_7 = { class: "fw-normal" }
const _hoisted_8 = { style: {"color":"var(--description-color)"} }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "fw-bold me-2" }
const _hoisted_12 = { class: "fw-normal" }
const _hoisted_13 = { style: {"color":"var(--description-color)"} }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "fw-bold me-2" }
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = { style: {"color":"var(--description-color)"} }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "mb-1" }
const _hoisted_21 = { class: "fw-bold me-2" }
const _hoisted_22 = { class: "fw-normal" }
const _hoisted_23 = { style: {"color":"var(--description-color)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("project.previewAndReport.consumption.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("project.previewAndReport.consumption.f1Total")), 1),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.consumptionData.totalF1), 1),
            _cache[0] || (_cache[0] = _createTextVNode(" kWh"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("project.previewAndReport.consumption.f2Total")), 1),
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.consumptionData.totalF2), 1),
            _cache[1] || (_cache[1] = _createTextVNode(" kWh"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("project.previewAndReport.consumption.f3Total")), 1),
          _createElementVNode("span", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.consumptionData.totalF3), 1),
            _cache[2] || (_cache[2] = _createTextVNode(" kWh"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("project.previewAndReport.consumption.grandTotal")), 1),
          _createElementVNode("span", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.consumptionData.grandTotal), 1),
            _cache[3] || (_cache[3] = _createTextVNode(" kWh"))
          ])
        ])
      ])
    ])
  ]))
}